import classNames from "classnames";
import React from "react";

import SingleValueFilterAbstract from "../../../../../../../abstract/SingleValueFilterAbstract";
import withTranslations from "../../../../../../../hocs/withTranslations";
import FilterOptionsHelper from "../../../../../../../lib/UniversalTable/CoreHelpers/FilterOptionsHelper";
import SelectInput from "../../../../inputs/SelectInput/SelectInput";

@withTranslations
class SingleValueFilter extends SingleValueFilterAbstract {
  getOptionPrefix(column) {
    if (FilterOptionsHelper.isTrendStatusColumn(column)) {
      return "trend_status_";
    }

    if (column.values_type !== "generated_in_frontend") {
      return;
    }

    switch (column.attribute_name) {
      case "transaction_type": {
        return "insider_transaction_type_";
      }
    }
  }

  render() {
    const { column, value, translate } = this.props;
    const isRuleset = column.filter_type === "ruleset";

    const optionPrefix = this.getOptionPrefix(column);

    const options = this.mapOptionsList(column.filter_data, {
      labelPrefix: optionPrefix,
      isRuleset
    });
    const calculatedValue = this.getSelectedOptions(options, value, isRuleset);

    return (
      <div
        className={classNames({
          "filters-item-wrapper": true,
          "half-width": true
        })}
      >
        <SelectInput
          label={translate(column.label)}
          options={options}
          value={calculatedValue}
          isMulti={!isRuleset}
          onChange={nextValue => this.handleChange(nextValue)}
          hasSelectAll={false}
          disableSearch
          disabled={this.props.disabled}
          overrideStrings={{
            selectSomeItems: translate(column.label),
            allItemsAreSelected: translate("All items are selected"),
            selectAll: translate("Select All"),
            search: translate("Search")
          }}
        />
      </div>
    );
  }
}

export default SingleValueFilter;
